module.exports = __webpack_public_path__ + "img/website.604b8405.svg";